import React from "react";
import Form from "../../components/form";
import IconButton from "@mui/material/IconButton";
import PhotoCamera from "@mui/icons-material/PhotoCamera";

let opcoes = [
  { value: "diretor", desc: "diretor" },
  { value: "coodenador", desc: "coodenador" },
  { value: "mantenedor", desc: "mantenedor" },
];

let opcoesSelecionados = ["diretor", "coodenador"];

// let opcoesSelecionadas = opcoes.filter((o) => o.value.includes(o.value));

// console.log('opcoes', opcoesSelecionadas);

const FormExemplo = ({ history, location }) => {
  const formSubmit = (form) => {
    history.push("app/testes/tabela-r");
    //console.log('submit', form);
  };

  const fExemplo = {
    title: "Formulário exemplo",
    form: {
      texto: {
        label: "Texto simples",
        type: "text",
        value: "Valor A",
        required: true,
      },
      textoReadOnly: {
        label: "Texto read only",
        type: "text",
        value: `O fim do ano finalmente está aqui! Foi cansativo, foi desafiador, foi corrido, mas está acabando! A gente sabe que todo mundo está precisando relaxar e comemorar, por isso queria fazer um convite especial:
                Nesta quinta-feira (09/12), nós vamos fazer uma confraternização de fim de ano no famoso Janela (Alameda Prudente de Moraes, 1295), no fim do expediente (lá pelas 18h!). Todos que comparecerem vão receber um vale de 35,00 no Alelo, para comer os hambúrguers sensacionais que eles têm. Vamos ficar na parte de cima do bar, que é bem confortável (um monte de sofás para sentar!) e vai ser fechada para nós, então não precisamos ter contato com pessoas estranhas (a não ser que você queira). Se você quiser comparecer, é só responder essa mensagem com um “Eu vou!”.
                Esperamos você lá!`,
        required: true,
        readOnly: true,
        onClick: () => alert("clicou!"),
      },
      numero: {
        label: "Número",
        type: "number",
        space: 6,
      },
      data: {
        label: "Data",
        type: "date",
        space: 6,
      },
      select1: {
        label: "Select (opções escritas)",
        type: "select",
        emptyItem: true,
        space: 6,
        options: [
          {
            value: 1,
            desc: "Opção 1",
          },
          {
            value: 2,
            desc: "Opção 2",
          },
          {
            value: 3,
            desc: "Opção 3",
          },
        ],
      },

      select2: {
        label: "Select (opções via array)",
        type: "select",
        emptyItem: true,
        space: 6,
        array: {
          data: [
            { id: 1, nome: "Rafael" },
            { id: 2, nome: "Heyverson" },
            { id: 3, nome: "Luan" },
          ],
          value: "id",
          desc: "nome",
        },
      },

      select3: {
        label: "Múltiplas opções",
        type: "select-multiple",
        emptyItem: true,
        space: 6,
        options: opcoes,
        value: opcoesSelecionados,
      },
      areaTexto: {
        label: "Área de texto",
        type: "textarea",
      },
      arquivo: {
        label: "Arquivo",
        type: "file",
        accept: "image/png, image/gif, image/jpeg",
        space: 4,
      },
      componente: {
        label: "Componente",
        type: "component",
        space: 4,
        value: (
          <IconButton
            color="primary"
            aria-label="upload picture"
            component="span"
            onClick={() => alert("sou um componente com vida própria")}
          >
            <PhotoCamera />
          </IconButton>
        ),
      },
    },
    urlParams: true,
    submit: {
      label: "Enviar",
      action: formSubmit,
      //auto: true,
    },
    history: history,
    location: location,
    close: {
      label: "Cancelar",
      action: () => alert("Cancelar!"),
    },
    customActions: [
      {
        label: "Ação 1",
        action: () => alert("Ação 1!"),
      },
      {
        label: "Ação 2",
        action: () => alert("Ação 2!"),
      },
    ],
  };

  return <Form formData={fExemplo} />;
};

export default FormExemplo;
